import { render } from "./PatientRepresentativeCordination.vue?vue&type=template&id=53a13c76&ts=true"
import script from "./PatientRepresentativeCordination.ts?vue&type=script&lang=ts&external"
export * from "./PatientRepresentativeCordination.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__